module.exports = __webpack_public_path__ + "img/pr-5.19ca1ddf.png";